import { render } from "./veiculos-list.vue?vue&type=template&id=0b891e16"
import script from "./veiculos-list.vue?vue&type=script&lang=js"
export * from "./veiculos-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__